export default "__VITE_ASSET__Ct0nk03C__"